import React, {ReactNode} from 'react'
import SVGDown from '../../../../../assets/icons/chevron-down-thick.svg'
import {
  EditorWrap,
  IconWrap,
  Label,
  RightIconClickThroughWrapper,
  StyledTextEditor,
  TextEditorWrapper,
  Wrapper
} from '../../../../../components/library/text-editor/styles'

export type SelectProps = {
  label: string
  icon?: ReactNode
  upLabel?: string
  readOnly?: boolean
  onChange?: (value: string) => void
  compact?: boolean
} & Omit<React.HTMLProps<HTMLSelectElement>, 'onChange'>

export const Select = ({
  label,
  icon,
  upLabel,
  readOnly,
  onChange,
  children,
  compact,
  ...props
}: SelectProps) => {
  const [focused, setFocused] = React.useState<boolean>(false)
  return (
    <TextEditorWrapper readOnly={readOnly} className={compact ? 'compact' : ''}>
      {icon ? <IconWrap>{icon}</IconWrap> : null}
      <EditorWrap>
        <Wrapper className={props.value || focused ? 'labelUp' : ''}>
          {compact ? null : (
            <Label>
              {props.value || focused || readOnly
                ? upLabel
                  ? upLabel
                  : label
                : label}
            </Label>
          )}
          <StyledTextEditor>
            <select
              {...props}
              disabled={readOnly}
              onFocus={e => {
                if (!readOnly) {
                  setFocused(true)
                }
                if (props.onFocus) {
                  props.onFocus(e)
                }
              }}
              onBlur={e => {
                setFocused(false)
                if (props.onBlur) {
                  props.onBlur(e)
                }
              }}
              onChange={e => {
                onChange?.(e.target.value)
              }}
            >
              {children}
            </select>
          </StyledTextEditor>
          <RightIconClickThroughWrapper>
            <SVGDown />
          </RightIconClickThroughWrapper>
        </Wrapper>
      </EditorWrap>
    </TextEditorWrapper>
  )
}
